(() => {
  const make = (tag, cls, text) => { const e = document.createElement(tag); if (cls) e.className = cls; if (text) e.textContent = text; return e; };
  const accordion = (heading, nodes) => {
    const d = make('details', 'info-accordion'); const summary = make('summary');
    summary.append(heading); const answer = make('div', 'info-answer'); answer.append(...nodes); d.append(summary, answer); return d;
  };
  function sections(article) {
    const groups = []; let group;
    [...article.children].forEach(node => {
      if (node.tagName === 'H2') { group = { heading: node, nodes: [] }; groups.push(group); }
      else if (group) group.nodes.push(node);
    });
    return groups;
  }
  function init(root) {
    if (root.dataset.enhanced) return; root.dataset.enhanced = 'true';
    const article = root.querySelector('article'); const type = root.dataset.infoPage;
    if (type === 'formats-finitions' && article.querySelector('[data-formats-horizontal]')) return;
    if (type === 'faq') {
      const names = ['Choisir son œuvre', 'Formats & finitions', 'Livraison', 'Retours & rétractation', 'Demandes particulières'];
      const buckets = names.map((name, i) => { const s = make('section', 'info-faq-group'); s.id = `faq-${i + 1}`; s.append(make('h2', '', name)); return s; });
      let question; const questions = [];
      [...article.children].forEach(node => { if (node.tagName === 'H3') { question = { heading: node, nodes: [] }; questions.push(question); } else if (node.tagName === 'H2') question = null; else if (question) question.nodes.push(node); });
      const placement = [0, 1, 1, 1, 2, 2, 2, 2, 3, 4];
      const nav = make('nav', 'info-category-nav'); nav.setAttribute('aria-label', 'Catégories de la FAQ');
      names.forEach((name, i) => { const a = make('a', '', name); a.href = `#faq-${i + 1}`; nav.append(a); });
      questions.forEach((q, i) => buckets[placement[i] ?? 4].append(accordion(q.heading, q.nodes)));
      article.replaceChildren(nav, ...buckets);
    } else if (type === 'formats-finitions') {
      const intro = []; for (const n of [...article.children]) { if (n.tagName === 'H2') break; intro.push(n); }
      const groups = sections(article); const cards = make('div', 'info-supports');
      groups.slice(0, 3).forEach((g, i) => {
        const card = make('section', 'info-support'); card.append(make('span', 'info-index', `0${i + 1}`), g.heading);
        const secondary = g.nodes.filter(n => /installation|Utilisez|accroche murale|fixation au mur/i.test(n.textContent));
        card.append(...g.nodes.filter(n => !secondary.includes(n)));
        if (secondary.length) card.append(accordion(make('h3', '', 'Installation'), secondary));
        cards.append(card);
      });
      article.replaceChildren(...intro, cards, ...groups.slice(3).map(g => {
        if (g.heading.id !== 'accrochage-alu') return accordion(g.heading, g.nodes);
        const installation = make('section', 'info-section info-installation');
        installation.append(g.heading, ...g.nodes);
        return installation;
      }));
      if (location.hash === '#accrochage-alu') requestAnimationFrame(() => {
        article.querySelector('#accrochage-alu')?.scrollIntoView({block: 'start', behavior: 'instant'});
      });
    } else {
      const groups = sections(article);
      const content = make('div', 'info-sections');
      const nav = make('nav', 'info-toc'); nav.setAttribute('aria-label', 'Sommaire');
      nav.append(make('p', 'info-nav-label', 'Sommaire'));
      groups.forEach((g, i) => {
        const s = make('section', 'info-section'); s.id = `information-${i + 1}`;
        if (/Annexe/.test(g.heading.textContent)) s.classList.add('info-withdrawal-model');
        s.append(g.heading, ...g.nodes); content.append(s);
        const a = make('a', '', g.heading.textContent); a.href = `#${s.id}`; nav.append(a);
      });
      // Preserve introductory content before the first heading.
      const intro = []; for (const n of [...article.children]) { if (n.tagName === 'H2') break; intro.push(n); }
      article.replaceChildren(...intro, ...(type === 'cgv' ? [nav] : []), content);
    }
    article.querySelectorAll('table').forEach(table => { const wrap = make('div', 'info-table-wrap'); table.before(wrap); wrap.append(table); });
  }
  const run = () => document.querySelectorAll('.roscoff-information-page').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  document.addEventListener('shopify:section:load', run);
})();


